import { MediaItemData } from '../../models/mediaItemData'
import { StateItems } from './models'

export const mapToStateItems = (items: MediaItemData[]): StateItems =>
  items.reduce<StateItems>((stateItems, current) => {
    stateItems[current.id] = current
    return stateItems
  }, {})
